import { render, staticRenderFns } from "./MarkAsDelivered.vue?vue&type=template&id=8eed693c"
import script from "./MarkAsDelivered.vue?vue&type=script&lang=ts"
export * from "./MarkAsDelivered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eed693c')) {
      api.createRecord('8eed693c', component.options)
    } else {
      api.reload('8eed693c', component.options)
    }
    module.hot.accept("./MarkAsDelivered.vue?vue&type=template&id=8eed693c", function () {
      api.rerender('8eed693c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/MarkAsDelivered.vue"
export default component.exports